import React, { useState } from "react";
import styles from "./style.module.css";
import ImageSelfProduction from "../../Assets/imgSelfProductionBenefits.png";
import usinaIeadpeTiuma from "../../Assets/usina-ieadpe-tiuma.jpg";
import usinaEplast from "../../Assets/usina-eplast2.png";
import usinaFortlev from "../../Assets/usina-fortlev.jpg";
import usinaRdg from "../../Assets/usina-rdg.jpeg";
import usinaPrd from "../../Assets/usina-prd.jpeg";

export default function Compare() {
  const ourProjects = [
    {
      image: usinaFortlev,
      name: "Fortlev",
      power: "1180,85 kWp",
      alt:
        "Vista aérea da usina solar com painéis fotovoltaicos instalados na cobertura industrial — 1180,85 kWp",
      featured: true,
    },
    {
      image: usinaRdg,
      name: "RDG",
      power: "556,96 kWp",
      alt:
        "Usina solar instalada em área industrial com painéis fotovoltaicos — 556,96 kWp",
      featured: false,
    },
    {
      image: ImageSelfProduction,
      name: "Autoprodução",
      power: "1274,12 kWp",
      alt:
        "Projeto de autoprodução solar com painéis fotovoltaicos de alta eficiência — 1274,12 kWp",
      featured: false,
    },
    {
      image: usinaEplast,
      name: "Eplast",
      power: "1520,90 kWp",
      alt:
        "Usina solar com grande estrutura de painéis fotovoltaicos em cobertura — 1520,90 kWp",
      featured: false,
    },
    {
      image: usinaPrd,
      name: "PRD",
      power: "6500 kWp",
      alt:
        "Usina solar com extensa área de captação de energia fotovoltaica — 6500 kWp",
      featured: true,
    },
    {
      image: usinaIeadpeTiuma,
      name: "IEADPE Tiuma",
      power: "700 kWp",
      alt: "Usina solar com instalação de painéis fotovoltaicos — 700 kWp",
      featured: false,
    },
  ];

  const [selectedProject, setSelectedProject] = useState(null);

  function openLightbox(project) {
    setSelectedProject(project);
    document.body.style.overflow = "hidden";
  }

  function closeLightbox() {
    setSelectedProject(null);
    document.body.style.overflow = "";
  }

  return (
    <div className={styles.totalInfo} id="projects">
      <div className={styles.sectionGrid}>
        <h2 className={styles.title}>Nossos Projetos</h2>

        <div className={styles.projectsGrid}>
          {ourProjects.map((project, index) => (
            <div
              key={index}
              className={`${styles.gridItem} ${
                project.featured ? styles.gridItemFeatured : ""
              }`}
              onClick={() => openLightbox(project)}
              role="button"
              aria-label={`Ver detalhes do projeto`}
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && openLightbox(project)}
            >
              <img
                className={styles.gridImage}
                src={project.image}
                alt={project.alt}
              />
              <div className={styles.gridCaption}>
                {/* <span className={styles.gridCaptionName}>{project.name}</span> */}
                <span className={styles.gridCaptionPower}>{project.power}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedProject && (
        <div
          className={styles.lightboxOverlay}
          onClick={closeLightbox}
          role="dialog"
          aria-modal="true"
          aria-label={`Imagem em destaque`}
        >
          <div
            className={styles.lightboxContent}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className={styles.lightboxClose}
              onClick={closeLightbox}
              aria-label="Fechar imagem"
            >
              ✕
            </button>
            <img
              src={selectedProject.image}
              alt={selectedProject.alt}
              className={styles.lightboxImage}
            />
            <div className={styles.lightboxInfo}>
              {/* <span className={styles.lightboxName}>
                {selectedProject.name}
              </span> */}
              <span className={styles.lightboxPower}>
                {selectedProject.power}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
